export default __webpack_public_path__ + "static/media/red-btn.068ab645.png";